import { Button, notification } from "antd";
import Cropper, { ReactCropperElement } from "react-cropper";
function Crop(props: any) {
  const [Notifications, contextHolder] = notification.useNotification();

  return (
    <>
      {contextHolder}
      {props?.image?.file ? (
        <>
          <Cropper
            ref={props?.cropperRef as React.RefObject<ReactCropperElement>}
            src={props?.image?.url?.replace(/^http:\/\//i, "https://")}
            style={{ height: 400, width: "100%" }}
            guides={true}
            ready={(e: any) => {
              // Cropper.js (viewMode 0) lets the crop box grow only to the container
              // height. On a wide (desktop) container the image already fills that
              // height, so there is no empty space to extend into. Zoom the image out
              // slightly so the box can reach above/below it. When the image is already
              // shorter than the container (narrow/mobile), nothing changes.
              const cropper = e?.currentTarget?.cropper;
              if (!cropper) return;
              const container = cropper.getContainerData();
              const canvas = cropper.getCanvasData();
              if (container.height > 0 && container.width / container.height > 1.5 && canvas.height >= container.height - 1) {
                cropper.zoomTo(
                  (canvas.width / cropper.getImageData().naturalWidth) * 0.7
                );
                const zoomed = cropper.getCanvasData();
                cropper.setCropBoxData({
                  width: zoomed.width * 0.8,
                  height: zoomed.height * 0.8,
                  left: zoomed.left + zoomed.width * 0.1,
                  top: zoomed.top + zoomed.height * 0.1,
                });
              }
            }}
          />
          <div style={{ textAlign: "center", marginTop: 16 }}>
            <Button
              type="primary"
              onClick={() => {
                props?.setUploadeAvailable(true);
                props?.handleCrop();
              }}
              style={{ marginLeft: 16 }}
            >
              Crop Image
            </Button>
          </div>
        </>
      ) : (
        <div className="no-img">No Image available</div>
      )}
    </>
  );
}

export default Crop;